import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=08f71360&scoped=true"
import script from "./CategoryButton.vue?vue&type=script&lang=js"
export * from "./CategoryButton.vue?vue&type=script&lang=js"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=08f71360&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f71360",
  null
  
)

export default component.exports